import React, { useCallback, useEffect } from 'react';
import { isMobile } from 'react-device-detect';
import { useKeyPress } from '@24i/player-utils-react';
import { useTheme } from '@24i/nxg-sdk-higgs/src/hooks/useTheme';
import { StyledIcon as Icon, IconName } from '../../../Icons';
import { Button } from '../../../Button/styled';
const RenderDefaultIcon = (volume, muted, color, backgroundColor, styles) => {
    const getIcon = () => {
        if (muted) {
            return IconName.volume_off;
        }
        if (volume < 1 / 3) {
            return IconName.volume_0;
        }
        if (volume < 2 / 3) {
            return IconName.volume_50;
        }
        return IconName.volume_100;
    };
    return (React.createElement(Icon, { style: styles.icon, name: getIcon(), "data-test": "VolumeButton-Icon", className: "VolumeButton-Icon", color, backgroundColor }));
};
export const VolumeButton = ({ playerInstance, backgroundColor = 'transparent', color, disabledColor, className = '', show, hide, muted, volume, customIcon = RenderDefaultIcon, disabled, styles = {
    button: null,
    icon: null,
}, }) => {
    var _a, _b;
    const ARROW_STEP = 0.05;
    const { theme } = useTheme();
    const finalColor = color || ((_a = theme === null || theme === void 0 ? void 0 : theme.color) === null || _a === void 0 ? void 0 : _a.contrast1) || 'white';
    const finalDisabledColor = disabledColor || ((_b = theme === null || theme === void 0 ? void 0 : theme.color) === null || _b === void 0 ? void 0 : _b.contrast4) || 'gray';
    const iconColor = !disabled ? finalColor : finalDisabledColor;
    const upPress = useKeyPress('ArrowUp', true);
    const downPress = useKeyPress('ArrowDown', true);
    const MPress = useKeyPress('M', true);
    const mPress = useKeyPress('m', true);
    useEffect(() => {
        if (!disabled && upPress) {
            const currentVolume = playerInstance.volume;
            playerInstance.volume = Math.min(1, currentVolume + ARROW_STEP);
        }
    }, [upPress]);
    useEffect(() => {
        if (!disabled && downPress) {
            const currentVolume = playerInstance.volume;
            playerInstance.volume = Math.max(0, currentVolume - ARROW_STEP);
        }
    }, [downPress]);
    const onClick = useCallback((event) => {
        if (disabled)
            return;
        playerInstance.muted = !playerInstance.muted;
        if (isMobile) {
            show();
        }
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
    }, [playerInstance]);
    useEffect(() => {
        if (!mPress && !MPress)
            return;
        onClick(null);
    }, [MPress, mPress]);
    return (React.createElement(Button, { backgroundColor, disabled, onClick, style: styles.button, "data-test": "VolumeButton", testID: "volume_button", className: `VolumeButton ${className}`, onMouseEnter: show, onPress: show, onMouseLeave: hide, onBlur: hide }, customIcon(volume, muted, iconColor, backgroundColor, styles)));
};
//# sourceMappingURL=index.js.map